// extracted by mini-css-extract-plugin
export default {"container":"AddReservation_container__JC-xP","header":"AddReservation_header__U8cKf","body":"AddReservation_body__CWLqu"};